import React from "react";
import {connect} from "react-redux";

import LookSideBarAIPanel from "../look/LookSideBarAIPanel";


const QKBSidePanel = (props) => {

  const {aiSettings} = props;

  if (!aiSettings || !aiSettings.enableAI) {
    return null
  }

  return (
    <LookSideBarAIPanel/>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {aiSettings} = store.fabricatorState;
  return {
    isMobile,
    aiSettings,
  };
};

export default connect(mapStateToProps)(QKBSidePanel)
